import { render, staticRenderFns } from "./ParentChildStory.vue?vue&type=template&id=37db9cd6&scoped=true&"
import script from "./ParentChildStory.vue?vue&type=script&lang=js&"
export * from "./ParentChildStory.vue?vue&type=script&lang=js&"
import style0 from "./ParentChildStory.vue?vue&type=style&index=0&id=37db9cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db9cd6",
  null
  
)

export default component.exports